import * as types from './types';
import * as functions from './functions';

export const parseEspressoLog = (logFile) => ({
  type: types.PARSE_ESPRESSO_JOB,
  payload: functions.parseEspressoLog(logFile),
});

export const parseXCUITestLog = (logFile) => ({
  type: types.PARSE_XCUITEST_JOB,
  payload: functions.parseXCUITestLog(logFile),
});

export const parseNativeFrameworkTestCases = (testCases) => ({
  type: types.PARSE_NATIVE_FRAMEWORK_TEST_CASES,
  payload: functions.parseNativeFrameworkTestCases(testCases),
});

export const parseJUnit = (xmlContent) => ({
  type: types.PARSE_JUNIT,
  payload: functions.parseJUnit(xmlContent),
});
